export const convertMinutesToText = (rawMinutes) => {
  const hours = Math.floor(rawMinutes/60);
  const minutes = Math.floor(rawMinutes % 60);

  const hourText = hours > 1 ? "hours" : "hour";

  return `${!!hours ? `${hours} ${hourText} and ` : ""}${minutes} minutes`
}

export function mapCategoriesToOptions(categories) {
  return categories.map(cat => ({
    value: cat._id, 
    label: cat.name
  }))
}

// eslint-disable-next-line class-methods-use-this
export function generateId() {
  // eslint-disable-next-line func-names
  const S4 = function () {
    // eslint-disable-next-line no-bitwise
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}`);
}


// WEBPACK FOOTER //
// ./src/lib/utils.js